import { UserParticipant } from "./UserParticipant";

export class VariablePerformer extends UserParticipant {
    name: string
    varValue: string;
    varType: string;
    relation: string;
}